import {getAgentsSpacesPath} from '@github-ui/agent-sessions/utils/constants'
import {useNavigate} from '@github-ui/use-navigate'

import {AgentsCreateSpaceDialog} from './AgentsCreateSpaceDialog'

/**
 * Administration-only "new space" surface for /copilot/agents/spaces/new. Opens the
 * shared CreateSpaceDialog immediately; cancelling returns to the Spaces list, and a
 * successful create navigates to the new space's admin detail page.
 */
export function AgentsNewSpaceView() {
  const navigate = useNavigate()

  return (
    <AgentsCreateSpaceDialog
      closeDialog={() => navigate(getAgentsSpacesPath())}
      spacesBasePath={getAgentsSpacesPath()}
    />
  )
}
